import { BaseTable, Button, Loading, NumberInput, TableNumber } from "components";
import { concatBsi, SetItemPriceFormType, useList } from "../utils";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { PicturesSection } from "pages/Inventori/Register/ItemGroup/components";
import { convertNumber, useApi } from "utils";
import { PaginationType } from "..";
import toast from "react-hot-toast";
import { PERMISION } from "security";

export function TableSetItemPrice(props: {
    isLoading: boolean,
    pagination: PaginationType
    refetch: () => void,
    data: ReturnType<typeof useList>["data"]
}) {
    const api = useApi()
    const { control, getValues, formState } = useFormContext<SetItemPriceFormType>()

    const { fields } = useFieldArray({ control, name: "setItem" })

    const handleRowSubmit = async (index: number) => {

        const data = getValues(`setItem.${index}`)

        const finalData = [{
            product_id: data.product_id,
            price_retail: data.price_retail,
            wholesales_price: data.wholesales_price,
            distributor_price: data.distributor_price,
            factory_price: data.factory_price,
            online_price: data.online_price,
            special_arrangement_price: data.special_arrangement_price,
        }]

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/updateitemprice", finalData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message
                }
            ).then(() => {
                // props.pagination.page = 1
                props.refetch()
            }).catch(() => { }).finally(resolve)
        })
    };

    return (
        <div className="overflow-x-auto max-h-[calc(100vh-630px)]">
            <BaseTable className="border-collapse">
                <thead className="sticky top-50 p-1 z-[2] !bg-black !text-white">
                    <tr>
                        <th>NO</th>
                        <th>PICTURE</th>
                        <th>BSI</th>
                        <th>CODE</th>
                        <th>DESCRIPTION</th>
                        <th>AVERAGE PRICE</th>
                        <th>RETAIL</th>
                        <th>WHOLESALE</th>
                        <th>DISTRIBUTOR</th>
                        <th>FACTORY</th>
                        <th>ONLINE</th>
                        <th>SPECIAL ARANGEMENT</th>
                        <th>ACTION</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        props.isLoading || props.data.items.length === 0 ? (
                            <tr>
                                <td colSpan={15} className="text-center"><Loading loading={props.isLoading} errorText={props.isLoading ? "" : "No data available"} /></td>
                            </tr>
                        ) : (
                            props?.data?.items.map((field, index) => {
                                const isDisabled = concatBsi(field.buy, field.sell, field.inventory) === "BI"
                                return (
                                    <tr key={index}>
                                        <td>
                                            {TableNumber({
                                                dataLength: fields.length,
                                                pageCurrent: props.pagination.page,
                                                index: index,
                                                limit: props.pagination.limit,
                                                totalData: props.pagination.total,
                                            })}
                                        </td>
                                        <td>
                                            <PicturesSection
                                                dataPicture={field?.picture}
                                                items={1}
                                                className="size-[50px] my-[-10px]"
                                            />
                                        </td>
                                        <td>{concatBsi(field.buy, field.sell, field.inventory)}</td>
                                        <td>{field.product_code}</td>
                                        <td>{field.product_name}</td>
                                        <td className="text-right">{field.avg_price ? convertNumber(Number(field.avg_price)).intoCurrency : "-"}</td>
                                        

                                        <FormTableSection
                                            index={index}
                                            isDisabled={isDisabled}
                                            rowData={field}
                                        />

                                        <td>
                                            <Button
                                                type="button"
                                                color="primary"
                                                permission={PERMISION.INVENTORY.TRANSACTION.SET_ITEM_PRICE.CREATE}
                                                className="w-[100px]"
                                                onClick={() => handleRowSubmit(index)}
                                                loading={formState.isSubmitting ? "true" : undefined}
                                            >
                                                Save
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            }

                            ))}
                </tbody>
            </BaseTable>
        </div>
    )
}

function FormTableSection({
    index,
    isDisabled,
    rowData,
}: {
    index: number;
    isDisabled: boolean;
    rowData: ReturnType<typeof useList>["data"]["items"][number];
}) {
    const { control } = useFormContext<SetItemPriceFormType>();

    const priceFields = [
        "price_retail",
        "wholesales_price",
        "distributor_price",
        "factory_price",
        "online_price",
        "special_arrangement_price",
    ] as const;

    type PriceField = typeof priceFields[number];

    return (
        <>
            {priceFields.map((fieldName) => (
                <td key={fieldName}>
                    <Controller
                        control={control}
                        name={`setItem.${index}.${fieldName}` as `setItem.${number}.${PriceField}`}
                        render={({ field, fieldState }) => (
                            <NumberInput
                                inputClass="w-[150px]"
                                disabled={isDisabled}
                                error={fieldState.error?.message}
                                onValueChange={(value) => {
                                    field.onChange(value.floatValue ?? 0);
                                }}
                                value={field.value ?? 0}
                                textRight={true}
                            />
                        )}
                    />
                </td>
            ))}
        </>
    );
}